import React from "react";
import Editor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default function EditorCm(props) {
  const handleChangeText = (text) => props.setState(text);
  return (
    <Editor
      enableToolbar={true}
      onChange={handleChangeText}
      setContents={props.state || ""}
      setDefaultStyle="font-family: IranSans; min-height: 20vh; height: auto;"
      setOptions={{
        buttonList: buttonList.complex,
        font: ["IranSans", "IranSansBold", "Arial", "Impact", "Tahoma"],
      }}
    />
  );
}
